// extracted by mini-css-extract-plugin
var _1 = "NewsboardPostHeader-moduleNewsboardPostHeader__R9wAo";
var _2 = "NewsboardPostHeader-modulecontainer__jzch_";
var _3 = "NewsboardPostHeader-moduleskeleton__uDpux";
export { _1 as "NewsboardPostHeader", _2 as "container", _3 as "skeleton" }
